module.exports = __webpack_public_path__ + "img/14_32.067347d7.png";